export const marketTypeMapping = {
  "": "-----",
  B2B: "B2B",
  B2C: "B2C",
};
